import { useState } from "react";
import { Button, Modal } from "@heroui/react";
import { Icon } from "@iconify/react";

import { useDeletePackageOption } from "@/features/package-options/use-package-options.ts";

export function DeletePackageOptionModal({ optionId }: { optionId: number }) {
  const [isOpen, setIsOpen] = useState(false);

  const { mutateAsync, isPending } = useDeletePackageOption();

  return (
    <div>
      <Button isIconOnly variant="danger-soft" onPress={() => setIsOpen(true)}>
        <Icon className="size-6" icon="solar:trash-bin-minimalistic-bold" />
      </Button>

      <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
        <Modal.Backdrop isDismissable>
          <Modal.Container placement="center">
            <Modal.Dialog>
              <Modal.Header>
                <Modal.Heading>Подтверждение</Modal.Heading>
              </Modal.Header>
              <Modal.Body>
                Удалить опцию? Заказы, где она уже начислена, не изменятся.
              </Modal.Body>
              <Modal.Footer>
                <Button variant="ghost" onPress={() => setIsOpen(false)}>
                  Нет, назад
                </Button>

                <Button
                  isPending={isPending}
                  variant="danger"
                  onPress={() =>
                    mutateAsync({ optionId }).then(() => setIsOpen(false))
                  }
                >
                  Да, удалить
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </Modal.Container>
        </Modal.Backdrop>
      </Modal>
    </div>
  );
}
